var render = function render(){var _vm=this,_c=_vm._self._c;return _c('progress',{staticClass:"single__progress-bar",attrs:{"id":"individual-progress-bar","role":_vm.role,"max":_vm.ariaValuemax,"aria-label":_vm.ariaLabel,"aria-valuenow":_vm.ariaValuenow,"aria-valuemin":_vm.ariaValuemin,"aria-valuemax":_vm.ariaValuemax,"aria-valuetext":_vm.ariaValuetext || null},domProps:{"value":_vm.ariaValuenow}})
}
var staticRenderFns = []

export { render, staticRenderFns }